<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="activePrompt = true"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
    <vs-prompt
      v-if="activePrompt"
      class="email-compose"
      title="Update product"
      accept-text="Update"
      @cancel="activePrompt = false"
      @close="activePrompt = false"
      @accept="updateRecord"
      :active.sync="activePrompt"
    >
      <VuePerfectScrollbar
        class="scroll-area p-4"
        :settings="settings"
        :key="$vs.rtl"
      >
        <form @submit.prevent>
          <vs-input
            class="w-full mt-4"
            label="Name"
            v-model="params.data.name"
            name="name"
          />
          <div class="flex flex-wrap w-full">
            <div class="mt-4 w-1/2 pr-2">
              <label class="text-sm">Sale price</label>
              <vx-input-group>
                <vs-input v-model="params.data.sale_price" name="sale_price" />
                <template slot="append">
                  <div class="append-text bg-primary">
                    <span>TND</span>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div class="mt-4 w-1/2 pr-2">
              <label class="text-sm">Percentage</label>
              <vx-input-group>
                <vs-input v-model="params.data.percentage" name="percentage" />
                <template slot="append">
                  <div class="append-text bg-primary">
                    <span>%</span>
                  </div>
                </template>
              </vx-input-group>
            </div>
          </div>
          <div class="flex flex-wrap w-full">
            <div
              class="mt-4 w-1/2 pr-2"
              v-if="params.data.sale_price && params.data.percentage"
            >
              Client price: {{ client_price }}
            </div>
            <div
              class="mt-4 w-1/2 pl-2"
              v-if="params.data.sale_price && params.data.percentage"
            >
              Benefit: {{ benefit }}
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  name: "CellRendererProductActions",
  components: {
    VuePerfectScrollbar,
    vSelect,
  },
  data() {
    return {
      activePrompt: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
    };
  },
  computed: {
    client_price() {
      if (this.params.data.sale_price && this.params.data.percentage) {
        return (
          this.params.data.sale_price -
          (
            this.params.data.sale_price *
            (this.params.data.percentage / 100)
          ).toFixed()
        );
      }
      return null;
    },
    benefit() {
      if (this.params.data.sale_price && this.params.data.percentage) {
        return (
          this.params.data.sale_price *
          (this.params.data.percentage / 100)
        ).toFixed();
      }
      return null;
    },
  },
  methods: {
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    async deleteRecord() {
      // PREVIOUS IMPLEMENTATION

      // await this.$store.dispatch("REMOVE_PRODUCT", {
      //   _id: this.params.data._id,
      //   visibility: false,
      // });
      await this.$store.dispatch("DELETE_PRODUCT", {
        _id: this.params.data._id,
      });
      this.showDeleteSuccess();
    },
    async updateRecord() {
      const payload = {
        name: this.params.data.name,
        sale_price: +this.params.data.sale_price,
        percentage: +this.params.data.percentage,
        client_price: +this.client_price,
        benefit: +this.benefit,
      };
      await this.$store.dispatch("UPDATE_PRODUCT", {
        _id: this.params.data._id,
        payload,
      });
      this.activePrompt = false;
      this.showUpdateSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Deleted",
        text: "The selected product was successfully deleted",
      });
    },
    showUpdateSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Product Updated",
        text: "The selected product was successfully updated",
      });
    },
  },
};
</script>
